module.exports = __webpack_public_path__ + "img/zurich.9c1a17b7.png";